import { render, staticRenderFns } from "./RolesFilter.vue?vue&type=template&id=3d6ee156&"
import script from "./RolesFilter.vue?vue&type=script&lang=js&"
export * from "./RolesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports